import axios from 'axios'
// 村列表
export function getRegiontList (data) {
  return axios.get(`/system/region/pageList`, { params: data })
}
export function getRegiontDetail (id) {
  return axios.get(`/system/region/${id}`)
}
// 新增村
export function saveRegion (data) {
  return axios.post(`/system/region/save`, data)
}
export function updateRegion (data) {
  return axios.post(`/system/region/update`, data)
}
export function delregion (ids) {
  return axios.delete(`/system/region/${ids}`)
}